<template>
  <Layout tituloPagina="Sistema | Cuenta | Cambiar de plan VPN | Actualización del plan VPN">
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Selección de plan</h4>
          </div>
          <div class="card-body" style="min-height: 100px;">
            <div class="table-responsive">
              <table class="tblRouters table table-hover align-middle">
                <thead>
                  <tr>
                    <th><span class="h3">Caracteristicas</span></th>
                    <th v-show="estado_modulo">
                      <span class="h3">Plan {{plan_vpn_contratado.nombre}}</span>
                      <br>
                      <big class="text-success">
                        Plan actual
                      </big>
                    </th>
                    <th>
                      <span class="h3">Plan {{plan_vpn_seleccionado.nombre}}</span><br>
                      <big class="text-info">
                        Nuevo plan seleccionado
                      </big>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Descripción</td>
                    <td style="min-width: 300px;" v-show="estado_modulo">{{plan_vpn_contratado.descripcion}}</td>
                    <td style="min-width: 300px;">{{plan_vpn_seleccionado.descripcion}}</td>
                  </tr>
                  <tr>
                    <td>
                      Credencial de usuario para VPN
                    </td>
                    <td v-show="estado_modulo">
                      {{plan_vpn_contratado.max_usuarios != -1 ? 'hasta '+plan_vpn_contratado.max_usuarios+' usuarios' : 'Ilimitado'}}
                    </td>
                    <td>
                      {{plan_vpn_seleccionado.max_usuarios != -1 ? 'hasta '+plan_vpn_seleccionado.max_usuarios+' usuarios' : 'Ilimitado'}}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Precio mensual
                    </td>
                    <td v-show="estado_modulo">
                      ${{plan_vpn_contratado.precio_mensual}} USD
                    </td>
                    <td>
                      ${{plan_vpn_seleccionado.precio_mensual}} USD
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Precio anual
                    </td>
                    <td v-show="estado_modulo">
                      ${{plan_vpn_contratado.precio_anual}} USD <br>
                      <strong>{{costoAnualPocentaje(plan_vpn_contratado.precio_mensual, plan_vpn_contratado.precio_anual)}}</strong>
                    </td>
                    <td>
                      ${{plan_vpn_seleccionado.precio_anual}} USD <br>
                      <strong>{{costoAnualPocentaje(plan_vpn_seleccionado.precio_mensual, plan_vpn_seleccionado.precio_anual)}}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="text-right pb-4">
          <div class="btn-group">
            <button class="btn btn-secondary"
              @click="$router.go(-1)">
              <i class="mdi mdi-chevron-left"></i>
              Atras
            </button>

            <button class="btn btn-success" @click="actualizarModuloPlan()">
              <i class="mdi mdi-refresh"></i>
              {{estado_modulo ? 'Cambiar' : 'Activar'}} plan VPN
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <w-saldo></w-saldo>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import WSaldo from '@/views/sistema/cuenta/WSaldo.vue'
import CuentaSrv from '@/services/CuentaSrv.js'
export default {
  name: 'ActualizarPlanVpn',
  components: { Layout, WSaldo },
  data() {
    return {
      id_plan_seleccionado: null,

      estado_modulo: false,

      plan_vpn_contratado: {
        id:null,
        nombre: "",
        descripcion: "",
        max_credenciales: 0,
        precio_mensual: 0,
        precio_anual: 0,
      },

      plan_vpn_seleccionado: {
        id:null,
        nombre: "",
        descripcion: "",
        max_credenciales: 0,
        precio_mensual: 0,
        precio_anual: 0,
      }
    }
  },

  created: function () {
    var self = this

    self.id_plan_seleccionado = self.$route.params.id_plan

    self.cargarEstado(function() {
      self.cargarPlanSeleccionado()
    })
  },
  methods: {
    actualizarModuloPlan:function() {
      var self = this 
      let datos = {
        id_plan: self.plan_vpn_seleccionado.id
      }

      if(self.plan_vpn_contratado.id != null) Object.assign(datos, {id_plan_actual: self.plan_vpn_contratado.id})

      CuentaSrv.actualizarModuloPlanContratado('vpn', datos).then(response => {
        let mensaje = self.estado_modulo ? 'Se cambio correctamente el plan seleccionado' : 'Se activo correctamente el plan seleccionado'
        iu.msg.success(mensaje)

        self.$router.push({ name: 'sistemaCuenta'})
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo activar o cambiar plan'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarEstado: function(callback) {
      var self = this

      CuentaSrv.estadoModulo('vpn').then(response => {
        self.estado_modulo = response.data

        if(self.estado_modulo == true) self.cargarPlanContratado()
        if(callback) callback()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPlanContratado: function (){
      var self = this

      CuentaSrv.moduloPlanContratadoJSON('vpn').then(response => {
        self.plan_vpn_contratado = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPlanSeleccionado:function () {
      var self = this

      CuentaSrv.moduloPlanJSON('vpn', self.id_plan_seleccionado).then(response => {
        self.plan_vpn_seleccionado = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    
    },

    costoAnualPocentaje: function(precio_mensual, precio_anual){
      if(precio_anual < 0) return ''

      let total = precio_mensual * 12
      let porcentaje = ((total - precio_anual) * 100) / total

      if(porcentaje < 0) return ''

      return `Costo anual (incluye ${parseInt(porcentaje)}% de descuento)`
    }
  }
}
</script>

<style scoped>

</style>